import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Kiosk } from './kiosk.model';

export enum KioskActionTypes {
  LoadKiosks = '[Kiosk] Load Kiosks',
  AddKiosk = '[Kiosk] Add Kiosk',
  UpsertKiosk = '[Kiosk] Upsert Kiosk',
  AddKiosks = '[Kiosk] Add Kiosks',
  UpsertKiosks = '[Kiosk] Upsert Kiosks',
  UpdateKiosk = '[Kiosk] Update Kiosk',
  UpdateKiosks = '[Kiosk] Update Kiosks',
  DeleteKiosk = '[Kiosk] Delete Kiosk',
  DeleteKiosks = '[Kiosk] Delete Kiosks',
  ClearKiosks = '[Kiosk] Clear Kiosks',
}

export class LoadKiosks implements Action {
  readonly type = KioskActionTypes.LoadKiosks;

  constructor(public payload: { kiosks: Kiosk[] }) {}
}

export class AddKiosk implements Action {
  readonly type = KioskActionTypes.AddKiosk;

  constructor(public payload: { kiosk: Kiosk }) {}
}

export class UpsertKiosk implements Action {
  readonly type = KioskActionTypes.UpsertKiosk;

  constructor(public payload: { kiosk: Kiosk }) {}
}

export class AddKiosks implements Action {
  readonly type = KioskActionTypes.AddKiosks;

  constructor(public payload: { kiosks: Kiosk[] }) {}
}

export class UpsertKiosks implements Action {
  readonly type = KioskActionTypes.UpsertKiosks;

  constructor(public payload: { kiosks: Kiosk[] }) {}
}

export class UpdateKiosk implements Action {
  readonly type = KioskActionTypes.UpdateKiosk;

  constructor(public payload: { kiosk: Update<Kiosk> }) {}
}

export class UpdateKiosks implements Action {
  readonly type = KioskActionTypes.UpdateKiosks;

  constructor(public payload: { kiosks: Update<Kiosk>[] }) {}
}

export class DeleteKiosk implements Action {
  readonly type = KioskActionTypes.DeleteKiosk;
  constructor(public payload: { id: string }) {}
}

export class DeleteKiosks implements Action {
  readonly type = KioskActionTypes.DeleteKiosks;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearKiosks implements Action {
  readonly type = KioskActionTypes.ClearKiosks;
}

export type KioskActions =
  | LoadKiosks
  | AddKiosk
  | UpsertKiosk
  | AddKiosks
  | UpsertKiosks
  | UpdateKiosk
  | UpdateKiosks
  | DeleteKiosk
  | DeleteKiosks
  | ClearKiosks;
